/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


/** Unique tabs using H6 as an anchor **/
document.addEventListener("DOMContentLoaded", function(event) { 
  $($('.product__descriptionMobile').find('h6').get().reverse()).each(function(i) {
      var tabName = $(this).text();
      tabContent = '';
      //check if h6 has text inside
    if ($(this).text() != '') {
          //hide h6
        $(this).hide();
          //combine content between H6 elements
          $(this).nextUntil('h6').each(function() {
              tabContent = tabContent + this.outerHTML;
              //hide content
              $(this).hide();
          });
          //generate tab HTML
          $('.js-accordion1').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-unique-info" style="display:none;"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
          $('.js-accordion1').prepend('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-unique-trigger"><h4 class="product-single__accordion__title-text"><span class="custom-text">' + tabName + '</span></h4><span class="product-single__accordion__title-icon icon-fallback"><span class="icon-fallback__text">+</span></span></a>');
      } else {  
          //hide empty H6
          $(this).hide();
      }
  });

  $(".js-unique-trigger").click(function() {
    var thisItem = $(this).attr("href");
    var activeClass = "js-active";
    //check if clicked is active
    if ($(thisItem).hasClass(activeClass)) {
      //close current item
      $(this).removeClass(activeClass);
      $(thisItem)
      .removeClass(activeClass)
      .stop()
      .slideUp();
    } else {
      //open and activate this item
      $(thisItem)
      .addClass(activeClass)
      .stop()
      .slideDown();
      $(this).addClass(activeClass);
    }
    return false;
  });


  $($('.product__descriptionDesktop').find('h6').get().reverse()).each(function(i) {
      var tabName = $(this).text();
      tabContent = '';
      //check if h6 has text inside
    if ($(this).text() != '') {
          //hide h6
        $(this).hide();
          //combine content between H6 elements
          $(this).nextUntil('h6').each(function() {
              tabContent = tabContent + this.outerHTML;
              //hide content
              $(this).hide();
          });
          //generate tab HTML
          $('.js-accordion2').prepend('<div id="acc-unique-1'+ [i] +'" class="product-single__accordion__item1 js-unique-info1" style="display:none;"><div class="product-single__accordion__item-wrap1 rte">' + tabContent + '</div></div>');
          $('.js-accordion2').prepend('<a href="#acc-unique-1'+ [i] +'" class="product-single__accordion__title1 js-unique-trigger1"><h4 class="product-single__accordion__title-text1"><span class="custom-text">' + tabName + '</span></h4><span class="product-single__accordion__title-icon1 icon-fallback"><span class="icon-fallback__text">+</span></span></a>');
      } else {  
          //hide empty H6
          $(this).hide();
      }
  });

   $(".js-unique-trigger1").click(function() {
    var thisItem = $(this).attr("href");
    var activeClass = "js-active1";
    //check if clicked is active
    if ($(thisItem).hasClass(activeClass)) {
      //close current item
      $(this).removeClass(activeClass);
      $(thisItem)
      .removeClass(activeClass)
      .stop()
      .slideUp();
    } else {
      //open and activate this item
      $(thisItem)
      .addClass(activeClass)
      .stop()
      .slideDown();
      $(this).addClass(activeClass);
    }
    return false;
  });

  
});		